// ─── Catégories personnalisées et masquage — module PUR ──────────
// Demandé par Cédric le 15/08 : ajouter ses propres catégories, masquer les
// catégories PAR DÉFAUT sans jamais les modifier, et une SOUS-CATÉGORIE
// entièrement optionnelle sur les opérations et les lignes de budget.
//
// La configuration vit dans UN document par espace (`configFinance/{espaceId}`) :
//   { categoriesPerso: [{ id:'p_…', nom, emoji, sousCategories: [] }],
//     categoriesMasquees: ['scolaire', …],
//     sousCategoriesDefaut: { loyer: ['B009'] } }
//
// ⚠️ Masquer retire de la SAISIE, pas de l'HISTORIQUE : une opération classée
// dans une catégorie masquée la garde à l'affichage. Retirer une catégorie de
// l'historique reviendrait à réécrire le passé.
import { CATEGORIES_SAISIE } from '../data/categories.js';

export const CONFIG_DEFAUT = {
  categoriesPerso: [],
  categoriesMasquees: [],
  sousCategoriesDefaut: {},
};

// Une personnalisée se reconnaît à son préfixe — jamais de collision possible
// avec un id par défaut, qui est un mot nu.
export const estPerso = (id) => String(id || '').startsWith('p_');

export const idPerso = () => `p_${Math.random().toString(36).slice(2, 8)}`;

// Les catégories PROPOSÉES À LA SAISIE : les défauts non masqués, puis les
// personnalisées. Les défauts gardent leur clé i18n ; les personnalisées
// portent leur nom en dur — il n'y a pas d'i18n pour du personnel.
export function categoriesActives(config = CONFIG_DEFAUT) {
  const masquees = new Set(config?.categoriesMasquees || []);
  return [
    ...CATEGORIES_SAISIE.filter(c => !masquees.has(c.id)),
    ...(config?.categoriesPerso || []).map(c => ({ id: c.id, emoji: c.emoji || '🏷️', nom: c.nom })),
  ];
}

// Les sous-catégories d'une catégorie : celles du document perso, ou celles
// ajoutées à un défaut. Une liste vide = pas de sélecteur à l'écran.
export function sousCategoriesDe(id, config = CONFIG_DEFAUT) {
  if (estPerso(id)) {
    const c = (config?.categoriesPerso || []).find(x => x.id === id);
    return c?.sousCategories || [];
  }
  return (config?.sousCategoriesDefaut || {})[id] || [];
}

// Validation d'une personnalisée avant écriture. Motif en clair : il sera
// affiché tel quel.
export function validerCategoriePerso(nom, config = CONFIG_DEFAUT) {
  const n = String(nom || '').trim();
  if (!n) return { ok: false, motif: 'nomVide' };
  if (n.length > 30) return { ok: false, motif: 'nomTropLong' };
  const doublon = (config?.categoriesPerso || []).some(c => c.nom.toLowerCase() === n.toLowerCase());
  if (doublon) return { ok: false, motif: 'doublon' };
  return { ok: true, motif: '' };
}
